import React, { useState } from 'react'
import "./signup.css"
import { Autocomplete, CircularProgress, IconButton, InputAdornment, OutlinedInput, TextField, Typography } from '@mui/material'
import SignupLoginImage from '../../component/signup-image/SignupLoginImage'
import { useNavigate } from 'react-router-dom';
import RegisterUser from '../../Apis/RegisterUser';
import 'react-toastify/dist/ReactToastify.css';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { showToast } from '../../utils/toastUtils';
import 'react-phone-number-input/style.css'
import PhoneInput, { isPossiblePhoneNumber, parsePhoneNumber } from "react-phone-number-input";
import NLBLOGO from '../../assets/images/nlblogo.png'
import { countries, getCountryCode } from 'countries-list'


function SignUp() {
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = React.useState(false);
    const [userDetails_signup, setUserDetails_signup] = useState({
        name: '',
        email: '',
        role: '',
        orgName: '',
        password: '',
        countryCode: '',
        phoneNumber: '',
        country: '',
    })
    const [disableButton, setDisableButton] = useState(false)
    const [fieldValidation, setFieldValidation] = useState({
        isPhoneNumberValid: true,
        isEmailValid: true
    })
    const [phoneNumber , setPhoneNumber] = useState('')
    const [defaultCountryIsoCode, setDefaultCountryIsoCode] = useState('')

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    }

    const keypressHandler = (e) => {
        var invalidChars = [
            "-",
            "+",
            "e",
        ];
        if (invalidChars.includes(e.key)) {
            e.preventDefault();
        }
    }

    const phoneNumberChangeHandler = (val) => {
        setPhoneNumber(val)
        if (val) {
            if (val && isPossiblePhoneNumber(val)) {
                setFieldValidation({ ...fieldValidation, isPhoneNumberValid: true })
                let countryCode_PhoneNumber = `+${parsePhoneNumber(val).countryCallingCode}`
                setUserDetails_signup({ ...userDetails_signup, phoneNumber: val.replace(countryCode_PhoneNumber, ""), countryCode: countryCode_PhoneNumber })
            }
            else {
                setFieldValidation({ ...fieldValidation, isPhoneNumberValid: false })
            }
        }
        else {
            setFieldValidation({ ...fieldValidation, isPhoneNumberValid: true })
            setUserDetails_signup({ ...userDetails_signup, phoneNumber: "", countryCode: "" })
        }
    };

    const validateEmail = (email) => {
        const regX =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (regX.test(email)) {
            return true;
        } else {
            return false;
        }
    };

    const isCorporateMailAddress = (email) => {
        if (email.includes("gmail") ||
            email.includes("outlook") ||
            email.includes("yahoo") ||
            email.includes("hotmail") ||
            email.includes("icloud") ||
            email.includes("zoho") ||
            email.includes("protonmail")
        )
            return false
        else
            return true
    }

    const emailChangeHandler = (e) => {
        const emailValue = e.target.value
        if (emailValue) {
            setUserDetails_signup({ ...userDetails_signup, email: emailValue })
            if (validateEmail(emailValue)) {
                setFieldValidation({ ...fieldValidation, isEmailValid: true })
            }
            else {
                setFieldValidation({ ...fieldValidation, isEmailValid: false })
            }
        }
        else {
            setUserDetails_signup({ ...userDetails_signup, email: "" })
            setFieldValidation({ ...fieldValidation, isEmailValid: true })
        }
    }

    const countryChangeHandler = (value) => {
        if (value) {
            setUserDetails_signup({ ...userDetails_signup, country: value })
            let countryIsoCode = getCountryCode(value.name)
            setDefaultCountryIsoCode(countryIsoCode)
        }
        else {
            setUserDetails_signup({ ...userDetails_signup, country: '' })
        }
    }

    const handleLogin = () => {
        navigate('/')
    }

    const formSubmit = async () => {
        try {
            if (!fieldValidation.isPhoneNumberValid) {
                showToast('Please enter a valid phone number', 'error')
                return
            }
            else if (!fieldValidation.isEmailValid) {
                showToast('Please enter a valid email address', 'error')
                return
            }
            else if (!isCorporateMailAddress(userDetails_signup.email)) {
                showToast('We apologize! A company email is required to create a Noah account', 'error')
                setFieldValidation({ ...fieldValidation, isEmailValid: false })
                return
            }
            else if (userDetails_signup.name === '' || userDetails_signup.email === '' || userDetails_signup.role === '' ||
                userDetails_signup.password === '' || userDetails_signup.countryCode === '' || userDetails_signup.phoneNumber === '' || userDetails_signup.orgName === '') {
                showToast('Please fill all the fields', 'error')
                return
            }
            setDisableButton(true)
            let payload  = {
                name: userDetails_signup.name,
                email: userDetails_signup.email,
                role: userDetails_signup.role,
                orgName: userDetails_signup.orgName,
                password: userDetails_signup.password,
                countryCode: userDetails_signup.countryCode,
                phoneNumber: userDetails_signup.phoneNumber,
                countryISO: getCountryCode(userDetails_signup.country.name)
            }
            const response = await RegisterUser(payload);
            if (response.status === 200) {
                showToast(response?.data?.message, 'success')
                navigate('/')
            } else {
                setDisableButton(false)
                let errMessage = response?.response?.data?.detail || 'User Registration Failed'
                showToast(errMessage, 'error')
            }
        } catch (error) {
            setDisableButton(false)
            showToast('User Registration Failed', 'error')
            console.log('error', error)
        }
    }

    return (
        <div className='signup-page'>
            <SignupLoginImage />
            <div className='signup-Div'>
                <div className='signup-card'>
                    <Typography component="h5" variant="h5">Noah.ai</Typography>
                    <img src={NLBLOGO} alt='NLB Services' className='logo_brand' />

                    <Typography component="p" variant="p" className='signUpheading'>Free Sign Up</Typography>

                    <div className='inputFieldsContainer'>
                        <span>Full Name*</span>
                        <OutlinedInput
                            placeholder='Enter your name...'
                            value={userDetails_signup.name}
                            onChange={(e) => setUserDetails_signup({ ...userDetails_signup, name: e.target.value })}
                        />
                    </div>

                    <div className='inputFieldsContainer'>
                        <span>Email*</span>
                        <OutlinedInput
                            className={fieldValidation.isEmailValid ? null : "invalidField_signup"}
                            placeholder='Enter your email...'
                            value={userDetails_signup.email}
                            onChange={(e) => emailChangeHandler(e)}
                        />
                        {(!fieldValidation.isEmailValid &&
                            <span className="invalidPhoneError">
                                * Please enter a valid email
                            </span>)}
                    </div>
                    <div className='inputFieldsContainer'>
                        <span>Country*</span>
                        <Autocomplete
                            className='autocomplete_signup'
                            options={Object.values(countries) || []}
                            getOptionLabel={(option) => option.name}
                            onChange={(e, value) => countryChangeHandler(value)}
                            renderInput={(params) => <TextField placeholder='Select country...' {...params} />}
                        />
                    </div>
                    <div className='inputFieldsContainer phoneInput_signup'>
                        <span>Phone Number*</span>
                        <PhoneInput
                            international
                            defaultCountry={defaultCountryIsoCode}
                            className={fieldValidation.isPhoneNumberValid ? "textbox_phone_input_signup" : "textbox_phone_input_signup invalidField_signup"}
                            value={phoneNumber}
                            onChange={(e) => phoneNumberChangeHandler(e)}
                            onKeyPress={(e) => keypressHandler(e)}
                            placeholder="Enter your phone number..."
                        />
                        {(!fieldValidation.isPhoneNumberValid) ? (
                            <span className="invalidPhoneError">
                                * Invalid phone number
                            </span>
                        ) : (
                            ""
                        )}
                    </div>

                    <div className='inputFieldsContainer'>
                        <span>Role*</span>
                        <OutlinedInput
                            placeholder='Enter your role...'
                            value={userDetails_signup.role}
                            onChange={(e) => setUserDetails_signup({ ...userDetails_signup, role: e.target.value })}
                        />
                    </div>

                    <div className='inputFieldsContainer'>
                        <span>Organization Name*</span>
                        <OutlinedInput
                            placeholder='Enter organization name...'
                            value={userDetails_signup.orgName}
                            onChange={(e) => setUserDetails_signup({ ...userDetails_signup, orgName: e.target.value })}
                        />
                    </div>

                    <div className='inputFieldsContainer'>
                        <span>Password*</span>
                        <OutlinedInput
                            placeholder='Enter your password...'
                            className='passwordInput_signup'
                            type={showPassword ? 'text' : 'password'}
                            value={userDetails_signup.password}
                            onChange={(e) => setUserDetails_signup({ ...userDetails_signup, password: e.target.value })}
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label={showPassword ? 'hide the password' : 'display the password'}
                                        onClick={handleClickShowPassword}
                                        edge="end"
                                    >
                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            }
                        />
                    </div>

                    <button
                        className={disableButton ? 'signupButton loginButtonDisabled' : 'signupButton'}
                        type='submit'
                        onClick={(e) => formSubmit()}
                        disabled={disableButton}
                    >
                        <span>{disableButton ? "Please wait..." : "Sign up"}</span>
                        {disableButton && <CircularProgress className='cp_loginButton' />}
                    </button>

                    <div className='loginNoAccountMessageContainer'>
                        <span className='loginNoAccountMessage'>Already have an account? </span>
                        <span className='signup_login' onClick={disableButton ? null : handleLogin}> Log in</span>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default SignUp
